<!--
    Hauptkomponente der UAPP
    Diese ist Teil des Cores und für Änderungen an allen Apps gedacht.
    Alle appspezifischen Änderungen werden im Ordner dist\ gemacht.
-->
<!-- <ngx-loading [show]="loading"></ngx-loading> -->
<!-- <div [@routeAnimations]="prepareRoute(outlet)" class="animation-content"> -->
    <router-outlet #outlet="outlet" ></router-outlet>
<!-- </div> -->
<div #dialogContainer class="cdk-overlay-container" [@.disabled]="true"></div>
<simple-notifications></simple-notifications>
